import React, { createContext, useLayoutEffect, useState } from 'react';
import { useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const LocationHistoryContext = createContext({});

export const LocationHistoryProvider = (props) => {

  const [prevUrl, setPrevUrl] = useState(null);
  const [currentUrl, setCurrentUrl] = useState(null);
  const location = useLocation();
  const prevUrlRef = useRef(prevUrl);

  useLayoutEffect(() => {
    setPrevUrl(currentUrl);
    prevUrlRef.current = currentUrl;
    setCurrentUrl(document.location.href);
    window.gtag('event', 'page_view', {
      page_path: `${location.pathname}${location.search}`,
    });
  }, [location]);

  return (
    <LocationHistoryContext.Provider value={prevUrlRef}>
      {props.children}
    </LocationHistoryContext.Provider>
  );
};